import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { useT } from '../i18n/useT';
import './LegalPage.css';

/**
 * /terms et /privacy au design de la page de vente (noir, sable, logo OpenBro).
 * Texte : i18n/translations.js (`terms`, `privacy`), FR et EN, langue de LanguageContext.
 */

const SUPPORT_EMAIL = 'mia@openpro.ai';

const LABELS = {
  fr: { lang: 'EN', switchLabel: 'Switch to English', terms: 'Conditions générales', privacy: 'Confidentialité', rights: 'Tous droits réservés.' },
  en: { lang: 'FR', switchLabel: 'Passer en français', terms: 'Terms', privacy: 'Privacy', rights: 'All rights reserved.' },
};

export default function LegalPage({ kind }) {
  const { lang, toggleLang } = useLang();
  const t = useT();
  const page = kind === 'privacy' ? t.privacy : t.terms;
  const labels = LABELS[lang] || LABELS.fr;

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.lang = lang;
    document.title = `${page.title} · OpenBro`;
  }, [lang, page.title]);

  return (
    <div className="ol">
      <header className="ol-header">
        <div className="ol-wrap ol-header-row">
          <Link to="/" className="ol-logo"><img src="/logo-openbro.png" alt="OpenBro" /></Link>
          <button type="button" className="ol-lang" onClick={toggleLang} aria-label={labels.switchLabel}>{labels.lang}</button>
        </div>
      </header>

      <main className="ol-wrap ol-main">
        <Link to="/" className="ol-back">← {page.back}</Link>
        <h1>{page.title}</h1>
        {page.sections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            <p>{section.content}</p>
          </section>
        ))}
      </main>

      <footer className="ol-footer">
        <div className="ol-wrap ol-footer-row">
          <nav aria-label="Legal">
            <Link to="/terms">{labels.terms}</Link>
            <Link to="/privacy">{labels.privacy}</Link>
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </nav>
          <p>© {new Date().getFullYear()} OpenBro. {labels.rights}</p>
        </div>
      </footer>
    </div>
  );
}
